export default __webpack_public_path__ + "static/media/mortaleslogo.c654c035.svg";